import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import "../assets/css/HomePage.css";
import {  l1, l2, l3, l4 } from "../assets/images";

function getLangPath(path, lang) {
  if (lang === "bn") {
    if (path.startsWith("/bn")) return path;
    return `/bn${path.startsWith("/") ? path : "/" + path}`;
  }
  return path.startsWith("/") ? path : "/" + path;
}

/* ===== SEO helpers (каноникал, hreflang, OG/Twitter, JSON-LD) ===== */
function setMetaName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
function setMetaProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
// Порядок атрибутов строго: href → hreflang
function upsertLink(rel, href, extra = {}) {
  if (!href) return;
  let selector = `link[rel="${rel}"]`;
  if (extra.hreflang) selector += `[hreflang="${extra.hreflang}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
    document.head.appendChild(el);
  } else {
    el.setAttribute("href", href);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
  }
}
function stripQueryHash(url) {
  try {
    const u = new URL(url);
    u.search = "";
    u.hash = "";
    return u.toString();
  } catch {
    return url;
  }
}
function toAbsoluteUrl(maybeRelative) {
  if (!maybeRelative) return "";
  if (/^https?:\/\//i.test(maybeRelative)) return maybeRelative;
  return `${window.location.origin}${maybeRelative.startsWith("/") ? "" : "/"}${maybeRelative}`;
}

const Login = () => {
  const { pathname } = useLocation();
  const lang = pathname.startsWith("/bn") ? "bn" : "en";

  // твоя функция — оставляю для совместимости
  function setMetaTag(name, content) {
    let element = document.querySelector(`meta[name="${name}"]`);
    if (element) {
      element.setAttribute("content", content);
    } else {
      element = document.createElement("meta");
      element.name = name;
      element.content = content;
      document.head.appendChild(element);
    }
  }

useEffect(() => {
  // ===== Копирайтинг (EN → BN перевод готов) =====
  const titleEN = "HHBD Login — Manage Bets & Withdraw Instantly in BD";
  const descEN =
    "Log in to your HHBD account safely and instantly. Access your funds, claim bonuses, and withdraw via bKash. Enjoy secure encryption, quick access, and full Bangla support for all Bangladeshi casino users.";

  const titleBN = "HHBD লগইন — বাংলাদেশে বাজি পরিচালনা করুন এবং তাৎক্ষণিকভাবে উত্তোলন করুন";
  const descBN =
    "আপনার HHBD অ্যাকাউন্টে নিরাপদে এবং তাৎক্ষণিকভাবে লগ ইন করুন। আপনার তহবিল অ্যাক্সেস করুন, বোনাস দাবি করুন এবং বিকাশের মাধ্যমে উত্তোলন করুন। সমস্ত বাংলাদেশী ক্যাসিনো ব্যবহারকারীদের জন্য নিরাপদ এনক্রিপশন, দ্রুত অ্যাক্সেস এবং সম্পূর্ণ বাংলা সমর্থন উপভোগ করুন।";

  const keywordsEN =
    "HHBD Login, casino account BD, secure login Bangladesh, BDT withdrawal, player dashboard BD, account access casino";
  const keywordsBN =
    "HHBD লগইন, অ্যাকাউন্ট বিডি, নিরাপদ লগইন, বেটিং লগইন, উত্তোলন বাংলাদেশ, ক্যাসিনো প্রবেশ";

  const isBN = lang === "bn";

  // ===== ТРЕБОВАНИЯ: ВСЕ ОБЫЧНЫЕ ТАЙТЛЫ — UPPERCASE; В МИКРОРАЗМЕТКЕ ТОЖЕ UPPERCASE =====
  const pageTitle = (isBN ? titleBN : titleEN).toUpperCase(); // ✅ обычные тайтлы в верхнем регистре
  const pageDesc = isBN ? descBN : descEN;                     // meta description — обычный регистр
  const pageKeywords = isBN ? keywordsBN : keywordsEN;         // meta keywords — обычный регистр

  // Базовые <title> и meta
  document.title = pageTitle;                 // ✅ UPPERCASE
  setMetaTag("description", pageDesc);
  setMetaTag("keywords", pageKeywords);

  // URL-ы
  const origin = window.location.origin;
  const cleanPath = pathname || "/";
  const currentAbsUrl = stripQueryHash(`${origin}${cleanPath}`);

  // hreflang альтернативы (en/bn) и x-default
  const urlEn = `${origin}${cleanPath.replace(/^\/bn/, "") || "/"}`;
  const urlBn = `${origin}${getLangPath(cleanPath.replace(/^\/bn/, ""), "bn")}`;

  upsertLink("canonical", currentAbsUrl);
  upsertLink("alternate", urlEn, { hreflang: "en" });
  upsertLink("alternate", urlBn, { hreflang: "bn" });
  upsertLink("alternate", urlEn, { hreflang: "x-default" });

  // Open Graph (тайтл в UPPERCASE)
  const ogImage = toAbsoluteUrl(l1);
  setMetaProperty("og:type", "website");
  setMetaProperty("og:site_name", "HHBD");
  setMetaProperty("og:url", currentAbsUrl);
  setMetaProperty("og:title", pageTitle);      // ✅ UPPERCASE
  setMetaProperty("og:description", pageDesc); // обычный регистр
  setMetaProperty("og:image", ogImage);
  setMetaProperty("og:image:alt", isBN ? titleBN : titleEN); // alt — читаемый текст
  setMetaProperty("og:locale", isBN ? "bn_BD" : "en_US");
  setMetaProperty("og:locale:alternate", isBN ? "en_US" : "bn_BD");

  // Twitter (полный блок, тайтл в UPPERCASE, добавляем twitter:url)
  const twitterSite = "@HHBD_official";     // при необходимости замени
  const twitterCreator = "@HHBD_official";  // опционально
  const twitterImageAlt = isBN
    ? "HHBD-তে লগ ইন করুন - আপনার অ্যাকাউন্টে নিরাপদ অ্যাক্সেস এবং ক্যাসিনো এবং বেটিং গেমগুলিতে দ্রুত প্রবেশাধিকার।"
    : "Log in to HHBD – secure access to your account and quick entry to casino and betting games.";

  setMetaName("twitter:card", "summary_large_image");
  setMetaName("twitter:title", pageTitle);        // ✅ UPPERCASE
  setMetaName("twitter:description", pageDesc);   // обычный регистр
  setMetaName("twitter:image", ogImage);
  setMetaName("twitter:image:alt", twitterImageAlt);
  setMetaName("twitter:url", currentAbsUrl);      // ✅ добавлено
  if (twitterSite) setMetaName("twitter:site", twitterSite);
  if (twitterCreator) setMetaName("twitter:creator", twitterCreator);
  setMetaName("twitter:label1", isBN ? "অ্যাক্সেস" : "Access");
  setMetaName("twitter:data1", "Secure • Fast • Private");
  setMetaName("twitter:label2", isBN ? "পেমেন্ট" : "Payments");
  setMetaName("twitter:data2", "bKash • Nagad • Rocket • Crypto");


  
}, [lang, pathname]);

  return (
    <>
      {/* --- ENGLISH VERSION --- */}
      <script
  type="application/ld+json"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: (() => {
      const isBN = pathname.startsWith("/bn");
      const origin =
        typeof window !== "undefined" ? window.location.origin : "https://example.com";
      const currentAbsUrl =
        typeof window !== "undefined"
          ? stripQueryHash(`${origin}${pathname || "/"}`)
          : "https://example.com/login";

      // Page copy (JSON-LD fields UPPERCASE per your rule)
      const titleEN = "  HHBD Login — Manage Bets & Withdraw Instantly in BD";
      const descEN =
        "Log in to your HHBD account safely and instantly. Access your funds, claim bonuses, and withdraw via bKash. Enjoy secure encryption, quick access, and full Bangla support for all Bangladeshi casino users.";
      const titleBN = "HHBD লগইন — বাংলাদেশে বাজি পরিচালনা করুন এবং তাৎক্ষণিকভাবে উত্তোলন করুন";
      const descBN =
        "আপনার HHBD অ্যাকাউন্টে নিরাপদে এবং তাৎক্ষণিকভাবে লগ ইন করুন। আপনার তহবিল অ্যাক্সেস করুন, বোনাস দাবি করুন এবং বিকাশের মাধ্যমে উত্তোলন করুন। সমস্ত বাংলাদেশী ক্যাসিনো ব্যবহারকারীদের জন্য নিরাপদ এনক্রিপশন, দ্রুত অ্যাক্সেস এবং সম্পূর্ণ বাংলা সমর্থন উপভোগ করুন।";

      const pageTitleCaps = (isBN ? titleBN : titleEN).toUpperCase();
      const pageDescCaps  = (isBN ? descBN  : descEN );
      const inLang = isBN ? "bn" : "en";


      // Use l1 as primary image; fall back to favicon if needed
      const primaryImage =
        typeof l1 === "string"
          ? (/^https?:\/\//i.test(l1) ? l1 : `${origin}${l1.startsWith("/") ? "" : "/"}${l1}`)
          : `${origin}/favicon-512x512.png`;

      const jsonLd = [
        // WebPage
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "url": currentAbsUrl,
          "name": pageTitleCaps,
          "inLanguage": inLang,
          "description": pageDescCaps,
          "isPartOf": { "@type": "WebSite", "name": "HHBD", "url": origin },
          "primaryImageOfPage": primaryImage
        },

        // Organization
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": pageTitleCaps,
  "url": origin,
  "description": pageDescCaps,
  "logo": {l1}, 
  "address": {
    "@type": "PostalAddress",
    "addressCountry": {
      "@type": "Country",
      "name": "BD"
    },
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "support@ze77-bd.com",
      "availableLanguage": ["English", "বাংলা"]
    }
  ],

},

        // MobileApplication (no downloadUrl as requested)
        {
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": "HHBD APP",
          "inLanguage": inLang,
          "operatingSystem": "Android",
          "applicationCategory": "GameApplication",
          "url": `${origin}/app`,
          "image": primaryImage,
          "offers": {
            "@type": "Offer",
            "price": "0",
            
          },
          "publisher": {
            "@type": "Organization",
            "name": "HHBD",
            "url": origin
          }
        }
      ];

      return JSON.stringify(jsonLd);
    })()
  }}
/>

      {lang === "en" && (
<>
    <section className="zHHBD-loginhero">
      <div className="zHHBD-loginhero__bg">
        <div className="zHHBD-loginhero__overlay"></div>
        <div className="zHHBD-loginhero__flare zHHBD-loginhero__flare--1"></div>
        <div className="zHHBD-loginhero__flare zHHBD-loginhero__flare--2"></div>
      </div>

      <div className="zHHBD-loginhero__container">
        <div className="zHHBD-loginhero__content">
          <header className="zHHBD-loginhero__header">
            <h1 className="zHHBD-loginhero__title">
              HHBD Login – Secure Access to Your Casino Account
            </h1>
            <p className="zHHBD-loginhero__desc">
              Jump back into your entertainment space in a heartbeat. Sign in to continue with the best online{" "}
              <Link to="/games" className="zHHBD-loginhero__link">casino games</Link> and high-energy{" "}
              <Link to="/bet" className="zHHBD-loginhero__link">sports betting</Link> choices in Bangladesh. Your next highlight could be just one click away.
            </p>
          </header>

          <div className="zHHBD-loginhero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-loginhero__btn zHHBD-loginhero__btn--main"
              title="Join HHBD Now"
            >
              Join HHBD Now
            </a>
            <a
              href="/HHBD.apk"
              className="zHHBD-loginhero__btn zHHBD-loginhero__btn--ghost"
              title="Download APK"
            >
              Download APK
            </a>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD Login – Quick and protected access to your gaming account"
        >
          <img
            src={l1}
            alt="Confident man in a tuxedo pointing at a glowing login screen, symbolizing secure entry to HHBD."
            title="HHBD Login – Quick and protected access to your gaming account"
          />
        </a>
      </div>
    </section>

    {/* SECURITY SECTION */}
    <section className="zHHBD-logincards">
      <div className="zHHBD-logincards__bg">
        <div className="zHHBD-logincards__burst zHHBD-logincards__burst--1"></div>
        <div className="zHHBD-logincards__burst zHHBD-logincards__burst--2"></div>
      </div>

      <div className="zHHBD-logincards__container">
        <figure className="zHHBD-logincards__figure">
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="HHBD Casino – Enjoy live dealer games with authentic excitement in Bangladesh"
          >
            <img
              src={l2}
              alt="Smiling live dealer tossing chips on an HHBD table, bathed in warm golden light."
              title="HHBD Casino – Enjoy live dealer games with authentic excitement in Bangladesh"
              className="zHHBD-logincards__img"
            />
          </a>
        </figure>

        <header className="zHHBD-logincards__header">
          <h2 className="zHHBD-logincards__title">
            Sign In Securely to Your HHBD Account
          </h2>

          <p className="zHHBD-logincards__intro">
            Enter your credentials to safely reach your HHBD profile. We employ modern SSL encryption to protect your login and personal information end-to-end. Keeping your privacy intact is always our top focus.
          </p>
          <p className="zHHBD-logincards__intro">
            <strong>Forgot Password?</strong> No worries—use the recovery link to start a quick, secure reset. In a few guided steps, you’ll regain access and return to play without missing a beat.
          </p>
          <p className="zHHBD-logincards__intro">
            <strong>Don't Have an Account Yet?</strong> You’re minutes from premium entertainment. Registration is simple, fast, and free. Join players across Bangladesh today and unlock your welcome bonus.
          </p>
          <p className="zHHBD-logincards__intro">
            <strong>Two-Factor Authentication</strong> Strengthen your security by enabling 2FA in settings. Each login will require a verification code from your device, adding an extra layer of protection.
          </p>
        </header>

        <div className="zHHBD-logincards__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-logincards__btn"
            title="Join HHBD Now"
          >
            Join HHBD Now
          </a>
        </div>
      </div>
    </section>

    {/* TROUBLESHOOTING SECTION */}
    <section className="zHHBD-awaits">
      <div className="container hr-cont">
        <h2 className="zHHBD-awaits__title" title="Why You Should Log In">
          Why You Should Log In
        </h2>
      </div>

      <div className="zHHBD-awaits__gridmask"></div>
      <div className="zHHBD-awaits__spark zHHBD-awaits__spark--1"></div>
      <div className="zHHBD-awaits__spark zHHBD-awaits__spark--2"></div>

      <div className="zHHBD-awaits__card">
        <div className="zHHBD-awaits__holo">
          <figure className="zHHBD-awaits__fig">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD Login – Safe and swift access to your online gaming account"
            >
              <img
                src={l3}
                alt="Laptop with a bright “Login” prompt, indicating trusted entry to an HHBD account."
                className="zHHBD-awaits__img"
                title="HHBD Login – Safe and swift access to your online gaming account"
              />
            </a>
          </figure>
        </div>

        <div className="zHHBD-awaits__body">
          <div className="zHHBD-awaits__copy">
            <p className="zHHBD-awaits__text">
              <strong>Manage Your Funds</strong> Once signed in, handle deposits and withdrawals with ease. Our cashier is straightforward and available around the clock, so topping up or cashing out feels effortless.
            </p>
            <p className="zHHBD-awaits__text">
              <strong>Claim Exclusive Bonuses</strong> All promotions and{" "}
              <Link to="/bonuses" className="zHHBD-awaits__link">bonuses</Link> live on your profile. Log in to access daily free spins, tailored{" "}
              <Link to="/casino" className="zHHBD-awaits__link">casino</Link> offers, and the latest rewards in our sportsbook.
            </p>
            <p className="zHHBD-awaits__text">
              <strong>Track Your Performance</strong> Your dashboard shows a complete gaming and betting history. Reviewing results helps refine strategies and keep your bankroll on plan.
            </p>
            <p className="zHHBD-awaits__text">
              <strong>Play Your Favorite Games</strong> Your saved{" "}
              <Link to="/games" className="zHHBD-awaits__link">casino games</Link>,{" "}
              <Link to="/slots" className="zHHBD-awaits__link">slots</Link>, and live tables are ready when you are. Log in to resume instantly and continue your streak.
            </p>
          </div>

          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-awaits__btn"
            title="Login HHBD"
          >
            Login HHBD
          </a>
        </div>
      </div>
    </section>

    {/* EXTRA SECURITY REASSURANCE */}
    <section className="zHHBD-recovery">
      <div className="zHHBD-recovery__bg">
        <div className="zHHBD-recovery__glare zHHBD-recovery__glare--1"></div>
        <div className="zHHBD-recovery__glare zHHBD-recovery__glare--2"></div>
      </div>

      <div className="zHHBD-recovery__container">
        <figure className="zHHBD-recovery__figure">
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="HHBD Login – Safe and swift access to your online gaming account"
          >
            <img
              src={l4}
              alt="Laptop with a vivid “Login” screen, underlining secure access to an HHBD player account."
              className="zHHBD-recovery__img"
              title="HHBD Login – Safe and swift access to your online gaming account"
            />
          </a>
        </figure>

        <h2 className="zHHBD-recovery__title">
          Your Security Is Our Promise
        </h2>

        <div className="zHHBD-recovery__grid">
          <div className="zHHBD-recovery__card">
            <div className="zHHBD-recovery__text">
              <strong>Industry-Standard Encryption</strong> All traffic between your device and our servers is protected with advanced 256-bit SSL. The same level relied upon by banks, ensuring confidentiality and integrity end-to-end.
            </div>
          </div>
          <div className="zHHBD-recovery__card">
            <div className="zHHBD-recovery__text">
              <strong>Proactive Account Monitoring</strong> Our team continuously scans for unusual activity. If anything looks off, we secure your balance immediately and alert you with clear next steps.
            </div>
          </div>
          <div className="zHHBD-recovery__card">
            <div className="zHHBD-recovery__text">
              <strong>Your Privacy Matters</strong> We follow a strict privacy policy—your data is never sold. We use your information solely to deliver the best gaming experience possible on HHBD, with compliance and respect throughout.
            </div>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-recovery__btn"
          title="Login HHBD"
        >
          Login HHBD
        </a>
      </div>
    </section>
  </>




      )}

      {/* --- BENGALI VERSION --- */}
      {lang === "bn" && (
  <>
    <section className="zHHBD-loginhero">
      <div className="zHHBD-loginhero__bg">
        <div className="zHHBD-loginhero__overlay"></div>
        <div className="zHHBD-loginhero__flare zHHBD-loginhero__flare--1"></div>
        <div className="zHHBD-loginhero__flare zHHBD-loginhero__flare--2"></div>
      </div>

      <div className="zHHBD-loginhero__container">
        <div className="zHHBD-loginhero__content">
          <header className="zHHBD-loginhero__header">
            <h1 className="zHHBD-loginhero__title">
             HHBD লগইন - আপনার ক্যাসিনো অ্যাকাউন্টে নিরাপদ অ্যাক্সেস
            </h1>
            <p className="zHHBD-loginhero__desc">
              চোখের পলকে ফিরুন আপনার বিনোদনের দুনিয়ায়। সাইন ইন করুন এবং বাংলাদেশের সেরা অনলাইন{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">ক্যাসিনো গেমস</Link> ও হাই-এনার্জি{" "}
              <Link to={getLangPath("/bet", lang)} className="rr555-aviatorlux__link">স্পোর্টস বেটিং</Link> চালিয়ে যান। আপনার পরের হাইলাইট মুহূর্তটি হতে পারে এক ক্লিকের দূরত্বে।
            </p>
          </header>

          <div className="zHHBD-loginhero__ctas">
            <a
              href="https://haruvest.com/W7DZsfpK"
              className="zHHBD-loginhero__btn zHHBD-loginhero__btn--main"
              title="এখনই HHBD-এ যোগ দিন"
            >
              এখনই HHBD-এ যোগ দিন
            </a>
            <a
              href="/HHBD.apk"
              className="zHHBD-loginhero__btn zHHBD-loginhero__btn--ghost"
              title="APK ডাউনলোড করুন"
            >
              APK ডাউনলোড করুন
            </a>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          title="HHBD লগইন – আপনার গেমিং অ্যাকাউন্টে দ্রুত ও সুরক্ষিত প্রবেশ"
        >
          <img
            src={l1}
            alt="টাক্সেডো পরা আত্মবিশ্বাসী ব্যক্তি—জ্বলজ্বলে লগইন স্ক্রিনের দিকে ইশারা করছেন; নিরাপদ HHBD এন্ট্রি বোঝায়।"
            title="HHBD লগইন – আপনার গেমিং অ্যাকাউন্টে দ্রুত ও সুরক্ষিত প্রবেশ"
          />
        </a>
      </div>
    </section>

    {/* SECURITY SECTION */}
    <section className="zHHBD-logincards">
      <div className="zHHBD-logincards__bg">
        <div className="zHHBD-logincards__burst zHHBD-logincards__burst--1"></div>
        <div className="zHHBD-logincards__burst zHHBD-logincards__burst--2"></div>
      </div>

      <div className="zHHBD-logincards__container">
        <figure className="zHHBD-logincards__figure">
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="HHBD ক্যাসিনো – বাংলাদেশে লাইভ ডিলার গেমসের খাঁটি রোমাঞ্চ উপভোগ করুন"
          >
            <img
              src={l2}
              alt="উষ্ণ সোনালি আলোয় আলোকিত HHBD টেবিলে হাসিমুখে চিপ ছুঁড়ছেন লাইভ ডিলার।"
              title="HHBD ক্যাসিনো – বাংলাদেশে লাইভ ডিলার গেমসের খাঁটি রোমাঞ্চ উপভোগ করুন"
              className="zHHBD-logincards__img"
            />
          </a>
        </figure>

        <header className="zHHBD-logincards__header">
          <h2 className="zHHBD-logincards__title">
            সুরক্ষিতভাবে আপনার HHBD অ্যাকাউন্টে সাইন ইন করুন
          </h2>

        <p className="zHHBD-logincards__intro">
            আপনার ক্রেডেনশিয়াল দিন এবং নিরাপদে পৌঁছে যান আপনার HHBD প্রোফাইলে। আপনার লগইন ও ব্যক্তিগত তথ্য এন্ড-টু-এন্ড সুরক্ষায় রাখতে আমরা আধুনিক SSL এনক্রিপশন ব্যবহার করি। আপনার গোপনীয়তা রক্ষা করা—সবসময়ই আমাদের প্রথম অগ্রাধিকার।
          </p>
          <p className="zHHBD-logincards__intro">
            <strong>পাসওয়ার্ড ভুলে গেছেন?</strong> চিন্তার কিছু নেই—রিকভারি লিঙ্ক ব্যবহার করে দ্রুত ও নিরাপদ রিসেট শুরু করুন। কয়েকটি ধাপেই পুনরায় এক্সেস ফিরে পাবেন এবং বিনা বাধায় খেলায় ফিরতে পারবেন।
          </p>
          <p className="zHHBD-logincards__intro">
            <strong>এখনও অ্যাকাউন্ট নেই?</strong> প্রিমিয়াম এন্টারটেইনমেন্ট থেকে মাত্র কয়েক মিনিট দূরে আছেন। রেজিস্ট্রেশন সহজ, দ্রুত, এবং ফ্রি। আজই বাংলাদেশজুড়ে প্লেয়ারদের দলে যোগ দিন এবং আনলক করুন আপনার ওয়েলকাম বোনাস।
          </p>
          <p className="zHHBD-logincards__intro">
            <strong>টু-ফ্যাক্টর অথেনটিকেশন</strong> সেটিংসে 2FA চালু করে আপনার সিকিউরিটি আরও শক্ত করুন। প্রতিবার লগইনে আপনার ডিভাইস থেকে একটি ভেরিফিকেশন কোড প্রয়োজন হবে—যা দেবে অতিরিক্ত নিরাপত্তা স্তর।
          </p>
        </header>

        <div className="zHHBD-logincards__cta">
          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-logincards__btn"
            title="এখনই HHBD-এ যোগ দিন"
          >
            এখনই HHBD-এ যোগ দিন
          </a>
        </div>
      </div>
    </section>

    {/* TROUBLESHOOTING SECTION */}
    <section className="zHHBD-awaits">
      <div className="container hr-cont">
        <h2 className="zHHBD-awaits__title" title="কেন লগইন করবেন">
          কেন লগইন করবেন
        </h2>
      </div>

      <div className="zHHBD-awaits__gridmask"></div>
      <div className="zHHBD-awaits__spark zHHBD-awaits__spark--1"></div>
      <div className="zHHBD-awaits__spark zHHBD-awaits__spark--2"></div>

      <div className="zHHBD-awaits__card">
        <div className="zHHBD-awaits__holo">
          <figure className="zHHBD-awaits__fig">
            <a
              href="https://haruvest.com/W7DZsfpK"
              title="HHBD লগইন – আপনার অনলাইন গেমিং অ্যাকাউন্টে নিরাপদ ও দ্রুত প্রবেশ"
            >
              <img
                src={l3}
                alt="ল্যাপটপে উজ্জ্বল ‘Login’ প্রম্পট—একটি HHBD অ্যাকাউন্টে ভরসাযোগ্য প্রবেশের ইঙ্গিত।"
                className="zHHBD-awaits__img"
                title="HHBD লগইন – আপনার অনলাইন গেমিং অ্যাকাউন্টে নিরাপদ ও দ্রুত প্রবেশ"
              />
            </a>
          </figure>
        </div>

        <div className="zHHBD-awaits__body">
          <div className="zHHBD-awaits__copy">
            <p className="zHHBD-awaits__text">
              <strong>ফান্ড ম্যানেজ করুন</strong> সাইন ইন করার পর সহজেই ডিপোজিট ও উইথড্র করতে পারবেন। আমাদের ক্যাশিয়ার ২৪/৭ সুবিধাজনক—টপ-আপ বা ক্যাশআউট—সবকিছুই হয় অনায়াসে।
            </p>
            <p className="zHHBD-awaits__text">
              <strong>এক্সক্লুসিভ বোনাস দাবি করুন</strong> সব প্রোমো ও{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">গেমস</Link> আপনার প্রোফাইলেই থাকে। লগইন করলেই পাবেন ডেইলি ফ্রি স্পিন, পার্সোনালাইজড{" "}
              <Link to={getLangPath("/casino", lang)} className="rr555-aviatorlux__link">ক্যাসিনো</Link> অফার এবং আমাদের স্পোর্টসবুকে নতুন নতুন রিওয়ার্ড।
            </p>
            <p className="zHHBD-awaits__text">
              <strong>পারফরম্যান্স ট্র্যাক করুন</strong> আপনার ড্যাশবোর্ডে থাকে সম্পূর্ণ গেমিং ও বেটিং হিস্ট্রি। রেজাল্ট রিভিউ করলে কৌশল আরও নিখুঁত হয় এবং ব্যাংকরোল পরিকল্পনা অনুযায়ী থাকে।
            </p>
            <p className="zHHBD-awaits__text">
              <strong>প্রিয় গেম খেলুন</strong> আপনার সেভ করা{" "}
              <Link to={getLangPath("/games", lang)} className="rr555-aviatorlux__link">ক্যাসিনো গেমস</Link>,{" "}
              <Link to={getLangPath("/slots", lang)} className="rr555-aviatorlux__link">স্লটস</Link> এবং লাইভ টেবিল—সবই প্রস্তুত। লগইন করলেই তৎক্ষণাৎ রিজিউম করুন এবং জয়ের ধারাবাহিকতা বজায় রাখুন।
            </p>
          </div>

          <a
            href="https://haruvest.com/W7DZsfpK"
            className="zHHBD-awaits__btn"
            title="HHBD-এ লগইন করুন"
          >
            HHBD-এ লগইন করুন
          </a>
        </div>
      </div>
    </section>

    {/* EXTRA SECURITY REASSURANCE */}
    <section className="zHHBD-recovery">
      <div className="zHHBD-recovery__bg">
        <div className="zHHBD-recovery__glare zHHBD-recovery__glare--1"></div>
        <div className="zHHBD-recovery__glare zHHBD-recovery__glare--2"></div>
      </div>

      <div className="zHHBD-recovery__container">
        <figure className="zHHBD-recovery__figure">
          <a
            href="https://haruvest.com/W7DZsfpK"
            title="HHBD লগইন – আপনার অনলাইন গেমিং অ্যাকাউন্টে নিরাপদ ও দ্রুত প্রবেশ"
          >
            <img
              src={l4}
              alt="‘Login’ স্ক্রিনসহ ল্যাপটপ—একটি HHBD প্লেয়ার অ্যাকাউন্টে নিরাপদ এক্সেসের বার্তা দিচ্ছে।"
              className="zHHBD-recovery__img"
              title="HHBD লগইন – আপনার অনলাইন গেমিং অ্যাকাউন্টে নিরাপদ ও দ্রুত প্রবেশ"
            />
          </a>
        </figure>

        <h2 className="zHHBD-recovery__title">
          আপনার সিকিউরিটি—আমাদের অঙ্গীকার
        </h2>

        <div className="zHHBD-recovery__grid">
          <div className="zHHBD-recovery__card">
            <div className="zHHBD-recovery__text">
              <strong>ইন্ডাস্ট্রি-স্ট্যান্ডার্ড এনক্রিপশন</strong> আপনার ডিভাইস ও আমাদের সার্ভারের সব ট্রাফিক প্রটেক্টেড 256-বিট SSL দিয়ে—ব্যাংক যেটি ভরসা করে ঠিক সেই স্তরে—এন্ড-টু-এন্ড কনফিডেনশিয়ালিটি ও ইন্টেগ্রিটি নিশ্চিত করতে।
            </div>
          </div>
          <div className="zHHBD-recovery__card">
            <div className="zHHBD-recovery__text">
              <strong>প্রোঅ্যাকটিভ অ্যাকাউন্ট মনিটরিং</strong> আমাদের টিম অস্বাভাবিক কার্যকলাপ লাগাতার নজরে রাখে। কিছু সন্দেহজনক দেখলেই আমরা সঙ্গে সঙ্গে আপনার ব্যালান্স সুরক্ষিত করি এবং স্পষ্ট পরবর্তী ধাপ জানাই।
            </div>
          </div>
          <div className="zHHBD-recovery__card">
            <div className="zHHBD-recovery__text">
              <strong>আপনার প্রাইভেসি গুরুত্বপূর্ণ</strong> আমরা কঠোর প্রাইভেসি পলিসি মেনে চলি—আপনার ডেটা কখনো বিক্রি করা হয় না। শুধুমাত্র HHBD-এ সেরা গেমিং এক্সপেরিয়েন্স দিতে আপনার তথ্য ব্যবহার করা হয়—সম্পূর্ণ কমপ্লায়েন্স ও সম্মানের সাথে।
            </div>
          </div>
        </div>

        <a
          href="https://haruvest.com/W7DZsfpK"
          className="zHHBD-recovery__btn"
          title="HHBD-এ লগইন করুন"
        >
          HHBD-এ লগইন করুন
        </a>
      </div>
    </section>
  </>







      )}
    </>
  );
};

export default Login;
